import { render } from "./RetributionCards.vue?vue&type=template&id=7efc48dd"
import script from "./RetributionCards.vue?vue&type=script&lang=js"
export * from "./RetributionCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__